import { IconProps } from '../ui/Icon/types';
import Icon from '../ui/Icon';

export default function IconDoneAll(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M17.9999 6.99984L16.5899 5.58984L10.2499 11.9298L11.6599 13.3398L17.9999 6.99984ZM22.2399 5.58984L11.6599 16.1698L7.47991 11.9998L6.06991 13.4098L11.6599 18.9998L23.6599 6.99984L22.2399 5.58984ZM0.409912 13.4098L5.99991 18.9998L7.40991 17.5898L1.82991 11.9998L0.409912 13.4098Z"
        fill="currentColor"
      />
    </Icon>
  );
}
